export default __webpack_public_path__ + "static/multiple-popups-c2a022abfefe245628fae6ff6b3d38bc.png";